module.exports = __webpack_public_path__ + "media/images/icons/resize-height-b96c684284a1db5aba31a87676c85d5d.svg";